export default __webpack_public_path__ + "static/media/Delete.cf266481.svg";